<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter">
      <v-row class="mb-0">
        <v-col cols="12">
          <GradeClassStudentSelect
            @changed="gradeClassStudentChange"
            :disableGradeSelect="user.role.type === 'teacher'"
            :autoSyncClassByStudent="false"
            :autoSyncGradeByClass="false"
          />
        </v-col>
        <v-col v-if="viewIsPaid" cols="12" md="4" lg="4">
          <v-select
            v-model="isPaid"
            :items="states"
            clear-icon="mdi-close"
            item-text="name"
            item-value="value"
            label="Trạng thái"
            outlined
            dense
            clearable
            hide-details
          />
        </v-col>
        <v-col v-if="viewIsPaid" cols="12" md="4" lg="4">
          <v-select
            v-model="feeStatus"
            :items="status"
            clear-icon="mdi-close"
            item-text="name"
            item-value="value"
            label="Tình trạng đối soát"
            outlined
            dense
            clearable
            hide-details
          />
        </v-col>
      </v-row>
      <v-row class="d-flex justify-space-between mt-0">
        <v-col cols="12" md="8" lg="6" class="mb-0">
          <div class="d-flex justify-space-between align-center pt-1">
            <v-checkbox
              @change="useNoteChange()"
              v-model="useNote"
              class="my-0"
              label="Có ghi chú"
              hide-details
            ></v-checkbox>
            <v-checkbox
              @change="noUseNoteChange()"
              v-model="noUseNote"
              class="my-0"
              label="Không ghi chú"
              hide-details
            ></v-checkbox>
            <p></p>
          </div>
        </v-col>
        <div class="buttonSearch ml-6 d-flex justify-end align-end">
          <v-btn class="search-button" height="40" outlined @click="onFilterChanged"> Tìm kiếm </v-btn>
        </div>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
// TODO: filter with teacher
export default {
  props: {
    viewIsPaid: Boolean,
  },
  components: {
    GradeClassStudentSelect,
  },
  data() {
    return {
      classData: null,
      grade: null,
      student: null,
      useNote: null,
      noUseNote: null,
      isPaid: null,
      feeStatus: null,
      states: [
        { name: 'Đã thu', value: true },
        { name: 'Chưa thu', value: false },
      ],
      status: [
        { name: 'Đủ', value: 'correct' },
        { name: 'Thừa', value: 'over' },
        { name: 'Thiếu', value: 'under' },
      ],
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
    ...mapState('constant', ['attendanceStatus']),
    gradeId() {
      return { grade: get(this.grade, 'id') }
    },
    currentClassId() {
      return { currentClass: get(this.classData, 'id') }
    },
  },
  methods: {
    gradeClassStudentChange(data) {
      this.grade = data.grade
      this.classData = data.class
      this.student = data.student
    },
    async onFilterChanged() {
      let query = {
        grade: get(this.grade, 'id'),
        class: get(this.classData, 'id'),
        student: get(this.student, 'id'),
        isUseNote: this.useNote !== null ? `${this.useNote}` : null,
        isPaid: this.isPaid !== null ? `${this.isPaid}` : null,
        feeStatus: this.feeStatus || null,
      }
      this.$emit('onFilter', query)
    },

    useNoteChange() {
      if (this.useNote === true) {
        this.noUseNote = null
      } else {
        this.useNote = null
      }
    },
    noUseNoteChange() {
      if (this.noUseNote === true) {
        this.useNote = false
      } else {
        this.useNote = null
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .wrap_filter {
    display: block;
  }
  div.buttonSearch {
    padding-top: 24px;
    margin-left: 0px !important;
  }
}
</style>
